// frontend/src/pages/EventDetails.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import supabase from '../config/supabaseClient';
import { useTheme } from '../components/ThemeContext';

const EventDetails = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const { theme } = useTheme();

  useEffect(() => {
    async function fetchEvent() {
      setLoading(true);
      if (id) {
        const { data, error } = await supabase
          .from('etwic_events')
          .select('*')
          .eq('id', id)
          .single();
        if (!error) setEvent(data);
      }
      setLoading(false);
    }
    fetchEvent();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!event) return <div>No event found. <Link to="/events">Return to Events</Link></div>;

  // Helper to render full_description as bullets or with line breaks
  function renderDescription(desc) {
    if (!desc) return null;
    // Split into lines
    const lines = desc.split(/\r?\n/).filter(line => line.trim() !== '');
    // Find the index of the first bullet line
    const firstBulletIdx = lines.findIndex(line => line.trim().startsWith('•') || line.trim().startsWith('-'));
    if (firstBulletIdx !== -1) {
      // Render intro (if any) as a paragraph, then bullets as a list
      const intro = lines.slice(0, firstBulletIdx);
      const bullets = lines.slice(firstBulletIdx).filter(line => line.trim().startsWith('•') || line.trim().startsWith('-'));
      return (
        <>
          {intro.length > 0 && (
            <p style={{ color: '#333', fontSize: '1rem', marginBottom: 8, textAlign: 'left' }}>{intro.join(' ')}</p>
          )}
          <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em', marginBottom: 24 }}>
            {bullets.map((line, idx) => {
              const text = line.replace(/^\s*[•-]\s*/, '');
              return <li key={idx} style={{ color: '#333', fontSize: '1rem', lineHeight: 1.5, marginBottom: '0.3em', whiteSpace: 'normal', textAlign: 'left' }}>{text}</li>;
            })}
          </ul>
        </>
      );
    } else {
      // Render with line breaks
      return (
        <p style={{ color: '#333', fontSize: '1rem', marginBottom: 24, whiteSpace: 'pre-line' }}>{desc}</p>
      );
    }
  }

  return (
    <div>
      {/* Hero Image */}
      <div style={{
        width: '100%',
        maxHeight: 340,
        overflow: 'hidden',
        marginBottom: 32,
        borderBottomLeftRadius: 24,
        borderBottomRightRadius: 24,
        boxShadow: '0 4px 24px 0 #ff66001a',
        background: theme === 'dark' ? '#23232b' : undefined,
      }}>
        <img
          src={'/events.webp'}
          alt="Event Hero"
          style={{
            width: '100%',
            height: 340,
            objectFit: 'cover',
            display: 'block',
            filter: theme === 'dark' ? 'brightness(0.7)' : undefined,
          }}
        />
      </div>
      <div style={{
        maxWidth: 600,
        margin: '0 auto',
        background: theme === 'dark' ? '#23232b' : '#fff',
        borderRadius: 16,
        boxShadow: theme === 'dark' ? '0 4px 24px #111' : '0 4px 24px rgba(0,0,0,0.08)',
        padding: '2.5rem 2rem',
        fontFamily: 'Inter, Arial, sans-serif',
        color: theme === 'dark' ? '#fff' : undefined,
      }}>
        <h1 style={{
          color: '#FF6600',
          fontWeight: 900,
          fontSize: '2.2rem',
          marginBottom: 12,
          letterSpacing: '-1px'
        }}>{event.title}</h1>
        <p style={{
          color: theme === 'dark' ? '#fff' : '#555',
          fontSize: '1.1rem',
          marginBottom: 18
        }}>{event.short_description}</p>
        {renderDescription(event.full_description)}
        <div style={{
          background: theme === 'dark' ? '#18181b' : '#f7f7f7',
          borderRadius: 8,
          padding: '1rem 1.5rem',
          marginBottom: 24,
          display: 'flex',
          flexDirection: 'column',
          gap: 8
        }}>
          <span><b>Date:</b> {event.event_date}</span>
          <span><b>Time:</b> {event.event_time}</span>
          <span><b>Location:</b> {event.location}</span>
        </div>
        <Link to="/events" style={{
          display: 'inline-block',
          background: '#FF6600',
          color: '#fff',
          padding: '0.6rem 1.5rem',
          borderRadius: 6,
          textDecoration: 'none',
          fontWeight: 600,
          letterSpacing: '0.5px',
          boxShadow: theme === 'dark' ? '0 2px 8px #222' : '0 2px 8px rgba(255,102,0,0.08)'
        }}>
          ← Return to Events
        </Link>
      </div>
    </div>
  );
};

export default EventDetails;
